export * from '@primeuix/themes/lara/progressspinner';
export { default } from '@primeuix/themes/lara/progressspinner';
